export default __webpack_public_path__ + "static/media/loading.a6d6bbc8.svg";